import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';

import { getNotificationCount } from '../actions'

const mapStateToProps = state => ({
  dashboard: state.Dashboard,
  global: state.Global
});

const NavLinks = [
  { location: '/dashboard', title: 'Dashboard', role: 'renter', render: function () { } },
  { location: '/dashboard/inbox', title: 'Inbox', role: 'renter' },
  { location: '/dashboard/bookings', title: 'Bookings', role: 'renter' },
  { location: '/dashboard/manage-listings', title: 'Manage Listings', role: 'owner' },
  { location: '/dashboard/reports', title: 'Reports', role: 'owner' }];

class DashboardNavigation extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentLocation: location.hash.substr(1, location.hash.indexOf('?') >= -1 ? (location.hash.indexOf('?') - 1) : null)
    }
    this.trackNotifications = this.trackNotifications.bind(this);
    this.onNavChange = this.onNavChange.bind(this);
  }
  notificationTimeout = null
  componentWillMount() {
    this.trackNotifications();
  }

  componentWillUnmount() {
    if (this.notificationTimeout) { clearTimeout(this.notificationTimeout); }
  }

  componentDidUpdate(prevProps, prevState) {
    let currentLocation = location.hash.substr(1, location.hash.indexOf('?') > -1 ? (location.hash.indexOf('?') - 1) : undefined)
    if (prevState.currentLocation !== currentLocation) {
      this.setState({ currentLocation: currentLocation });
    }
  }

  trackNotifications() {
    let { dispatch } = this.props;
    let that = this;
    if (this.notificationTimeout) { clearTimeout(this.notificationTimeout) }
    dispatch(getNotificationCount());
    this.notificationTimeout = setTimeout(() => {
      that.trackNotifications();
    }, 10000)
  }

  renderDesktopView(notificationCount, navLinks) {
    return (<div className="row dashboard-navigation" ref={this.setWrapperRef}>
      {navLinks.map((link, i) => {
        if (i === 0) {
          return (<NavLink key={i} className="col" exact to={link.location} activeClassName="active"><h3>{link.title}</h3></NavLink>);
        }
        if (link.location.toLowerCase().indexOf('inbox') >= 0) {
          return (<NavLink key={i} className="col" to={link.location} activeClassName="active">
            <h3>Inbox {notificationCount > 0 && (<span className='badge'>{notificationCount}</span>)}</h3></NavLink>);
        }
        return (
          <NavLink key={i} className="col"
            to={link.location} activeClassName="active"
          ><h3>{link.title}</h3></NavLink>
        );
      })}
    </div>);
  }

  onNavChange({ target }) {
    let { history } = this.props;
    history.push(target.value);
  }

  renderMobileView(notificationCount, navLinks, currentLocation) {
    let currentNavLink = navLinks.filter(l => currentLocation.toLowerCase().indexOf(l.location.toLowerCase()) > -1);
    currentNavLink = currentNavLink.length > 0 ? currentNavLink[currentNavLink.length - 1] : navLinks[0];

    return (<div className="row dashboard-navigation">
      <div className="col mobile-navigation">
        <select onChange={this.onNavChange} value={currentNavLink.location}>
          {navLinks.map((link, i) => {
            if (link.location.toLowerCase().indexOf('inbox') >= 0) {
              return (<option key={i} value={link.location}>{notificationCount > 0 ? `${link.title} (${notificationCount})` : `${link.title}`}</option>);
            }
            return (<option key={i} value={link.location}>{link.title}</option>);
          })}
        </select>
        <i className="fas fa-angle-down fa-2x"></i>
      </div>
    </div>);
  }

  render() {
    let { dashboard, isMobile } = this.props;
    let { currentLocation } = this.state;
    let user = dashboard.user;
    let notificationCount = dashboard.notificationCount;
    if (user && user.notifications) { notificationCount += user.notifications.filter(n => !n.dismissed).length }
    let isOwner = user && user.userType === 'owner';
    let validLinks = isOwner ? NavLinks : NavLinks.filter(l => l.role === 'renter');

    return isMobile
      ? this.renderMobileView(notificationCount, validLinks, currentLocation)
      : this.renderDesktopView(notificationCount, validLinks);

  }
}


export default withRouter(connect(mapStateToProps)(DashboardNavigation));
